
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2023
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'сынақ',
	'visualizationSlideoutTitle': 'Көрнекі құралдар',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Санды енгізу',
	'maxValuePlaceholder': 'Санды енгізу',
	'customRangeErrorMessage': 'Мән сан болуы керек',
	'propFillColor': 'Түспен толтыру',
	'propBorderColor': 'Жиек түсі',
	'propBorderRadius': 'Бұрыш радиусы (px)',
	'propColorPalette': 'Ағымдағы түстер бояғышы',
	'propColorPaletteChangeLabel': 'Түсті бояғыштарды өзгерту',
	'propNewColorPaletteLabel': 'Пайдаланушылық түс бояғышты жасаңыз',
	'propNewHeatPaletteLabel': 'Теңшелетін жылу палитрасын жасау',
	'showTitleLabel': 'Тақырыпты көрсету',
	'titleTypeLabel': 'Тақырып түрі',
	'smartTitleLabel': 'Смарт тақырып',
	'customTitleLabel': 'Өзгермелі тақырып',
	'noTitleLabel': 'Тақырып жоқ',
	'colorPaletteTitle': 'Бояғыш',
	'responsiveTitleLabel': 'Жауапты тақырып',
	'propHeatScalePalette': 'Ағымдағы жылу бояғышы',
	'propHeatPaletteChangeLabel': 'Жылу бояғышын өзгертіңіз',
	'propMaintainAxisScales': 'Білік өлшемін сақтап қалу',
	'propLineAndSymbolColor': 'Сызық және нышан түсі',
	'propLineAndSymbolPalette': 'Сызықтық және символдық түстер палитрасы',
	'propElementColor': 'Элемент түсі',
	'propColumnColor': 'Баған түсі',
	'propColumnPalette': 'Баған түсті бояғыштары',
	'propColumnHeatPalette': 'Бағандық жылу палитрасы',
	'propBarColor': 'Жолақ түсі',
	'propGoalColor': 'Мақсаттық түс',
	'propToColor': 'Бояуға',
	'propFromColor': 'Бояудан',
	'propNumberValidationErrorMessageId': 'Санды енгізу',
	'fontSizeAuto': 'Авто',
	'propAutoBinCount': 'Топтар саны',
	'propAutoBinToggle': 'Автоматты топтау',
	'tabName_general': 'Жалпы',
	'tabName_visDetails': 'Мәліметтер',
	'tabName_animation': 'Анимация',
	'tabName_mediaDetails': 'Мультимедиа мәліметері',
	'tabName_webDetails': 'Веб парақша мәліметтері',
	'tabName_imageDetails': 'Кескін мәліметтері',
	'tabName_visualization': 'Көрнекі бейне',
	'tabName_text': 'Мәтін',
	'sectionName_colorsAndThemes': 'Түс және тақырыптар',
	'sectionName_appearance': 'Пайда болу',
	'sectionName_general': 'Жалпы',
	'sectionName_colorPalette': 'Түс',
	'sectionName_axis': 'Білік',
	'sectionName_axis_label': 'Білік',
	'sectionName_legend': 'Оқиға',
	'sectionName_chart': 'Диаграмма',
	'sectionName_regionLayer': 'Аймақтардың қабаты',
	'sectionName_pointLayer': 'Нүктелер қабаты',
	'sectionName_latLongLayer': 'Ендік/бойлық қабаты',
	'sectionName_pathLayer': 'Жол қабаты',
	'sectionName_xAxis': 'X осі',
	'sectionName_yAxis': 'Y осі',
	'sectionName_xAxis_title': 'X осінің тақырыбы',
	'sectionName_yAxis_title': 'Y осінің тақырыбы',
	'sectionName_xAxis_label': 'X осінің белгісі',
	'sectionName_yAxis_label': 'Y осінің белгісі',
	'sectionName_column_yAxis': 'Y баған осі',
	'sectionName_column_yAxis_label': 'Y баған осінің белгісі',
	'sectionName_column_yAxis_title': 'Y баған осінің тақырыбы',
	'sectionName_line_yAxis': 'Y сызығы осі',
	'sectionName_line_yAxis_label': 'Y сызығы осінің белгісі',
	'sectionName_line_yAxis_title': 'Y сызығының осінің тақырыбы',
	'sectionName_title': 'Тақырып',
	'sectionName_legendTitle': 'Мәндік белгілер тақырыбы',
	'sectionName_legendLabels': 'Мәндік белгілер',
	'sectionName_innerValueLabel': 'Ішкі мән белгісі',
	'sectionName_style': 'Мәнер',
	'propTransparencyDescription': 'Нысанды ашық немесе мөлдір етіп жасаңыз. 0 және 100 орталығында мәнді енгізіңіс',
	'smart_annotation_unauthorized': 'Аннотациялар: рұқсатсыз кіру',
	'smart_annotation_method': 'Аннотациялар: әдіс рұқсат етілмеді',
	'smart_annotation_media': 'Аннотациялар: ақпарат тасушы түрі рұқсат етілмеді',
	'smart_annotation_input': 'Аннотациялар: енгізу жарамсыз',
	'smart_annotation_internal': 'Аннотациялар: ішкі жүйе қатесі',
	'smart_annotation_generic_error': 'Аннотациялар: қызмет қатесі',
	'smart_annotation_dialog_title': 'Түсініктер',
	'smart_annotation_Show_Insights': 'Анықтамаларды көрсету',
	'smart_annotation_Relationship': 'Қарым-қатынас',
	'forecast_enter_number': 'Арасына сан енгізіңіз ',
	'and': ' және ',
	'smart_errors': 'Аннотация қателері:',
	'smart_warnings': 'Аннотация туралы ескертулер:',
	'smart_annotation_insight_icon_title': 'Түсініктер',
	'smart_annotations_toggle_on': 'Түсініктемелерді қосыңыз',
	'smart_annotations_toggle_off': 'Түсініктемелерді ажыратыңыз',
	'smart_annotation_toggle_on': 'Қосыңыз',
	'smart_annotation_toggle_off': 'Ажыратыңыз',
	'smart_annotation_insight_unavailable': 'Түсініктер қазіргі уақытта қол жетімді емес',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Жоғарғы немесе Төменгі % сүзгісі қолданылған кезде түсіндірмелер қол жетімді емес',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Жоғары немесе Төменгі % сүзгі қолданылған кезде болжам қол жетімді емес',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Сүзгілер жоғарғы немесе төменгі сүзгі қолданылғанда қол жетімді емес және өрісте бірнеше баған бар',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Болжам жоғарғы немесе төменгі сүзгі қолданылған кезде және өрісте бірнеше баған болса қол жетімді емес',
	'forecast_title': 'Болжам',
	'forecast_show': 'Болжамды көрсету',
	'forecast_toggle_on': 'Болжамдарды қосу',
	'forecast_toggle_off': 'Болжамдарды өшіру',
	'statDetails_title': 'Статистикалық мәліметтерді қараңыз',
	'forecast_optional_factors_max_info': 'Ең көп %{max} фактор қосуға болады',
	'forecast_optional_factors_num_added': '%{added}/%{max}',
	'forecast_optional_factors': 'Есепке алынатын қосымша факторлар',
	'forecast_optional_factors_placeholderDropzone': 'Деректерді мына жерге нұқыңыз немесе сүйреңіз',
	'forecast_item_tooltip': 'Бастапқы:',
	'insightsNarrator': 'Сипаттамалық мәліметтер',
	'statDetailsPerspectiveTitle': 'Талдау',
	'emptyStatDetailsPanel': 'Ешбір қосымша талдаулар ағымдағы көрнекілік үшін қолжетімді емес.',
	'predict_errors': 'Талдау қателері',
	'predict_warnings': 'Талдау туралы ескертулер',
	'fpd_invalid_data_source': 'Бұл деректер көзінде байланысты смарт-модуль жоқ',
	'fpd_network_issue': 'Бұл деректер көзіне талдау жасауда мәселе пайда болды',
	'fpd_data_source_category': 'Smarts модулі жоқ',
	'fpd_response_errors': 'Ұсынылған драйвер қателері',
	'fpd_response_warnings': 'Ұсынылған жүргізуші туралы ескертулер',
	'catalyst_service_bad_request': 'Жаман сұрау',
	'catalyst_service_unkown_Id': 'Белгісіз сұраныс идентификаторы табылды',
	'catalyst_service_internal_server_error': 'Ішкі сервер қатесі',
	'catalyst_service_generic_error': 'Catalyst қызмет қатесі',
	'catalyst_service_error': 'Бұл қызмет қазір қол жетімді емес',
	'propLegendPosition': 'Мәнді белгілер орналасуы',
	'propLeft': 'Сол',
	'propRight': 'Оң',
	'propTop': 'Үстіңгі',
	'propBottom': 'Төменгі',
	'propNone': 'Ешбір',
	'propLegendDisplay': 'Мәндік белгілерді көрсету',
	'targetThicknessPlaceHolder': '%{min}-дан  %{max}-ға',
	'targetThicknessErrorMsg': '%{min} мен %{max} аралығындағы бүтін санды енгізіңіз.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Драйверлер (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'таңдалған)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Әдепкілерне қайта қою',
	'possibelKeyDriver_AddNewDrivers': 'Қосымша драйверлерді қосыңыз',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Қосымша драйверлерді қосу үшін іздеу',
	'possibleKeyDrivers_MaxPossibleReached': 'Басқаларды қосу немесе таңдау үшін кейбір драйверлерді алып тастаңыз',
	'possibleKeyDrivers_Recommended': 'Ұсынылған',
	'visRecommendedTypes': 'Ұұсынылған көрнекі бейне түрлері',
	'visRecommender_smartsfailure': 'көрнекілендіру туралы ұсыныстар қазір қол жетімді емес',
	'visMore': 'Қосымша...',
	'visMoreTooltip': 'Қосымаща көрнекі бейнелеу',
	'visOtherTypes': 'Өзге көрнекі бейне түрлері',
	'visChange': 'Көрнекі бейнелерді өзгертіңіз',
	'automaticTypeCaption': 'Автоматты',
	'propVisType': 'Көрнекі бейне түрлері',
	'dlg_loading': 'Жүктелуде...',
	'snippetListChartCaption': 'Үзінділер тізімі',
	'convoClusterChartCaption': 'Сөйлесу кластері',
	'areaChartCaption': 'Аймақ',
	'barChartCaption': 'Тақта',
	'columnChartCaption': 'Баған',
	'stackedbarChartCaption': 'Қатталған жолақ',
	'stackedcolumnChartCaption': 'Қатталған баған',
	'bubbleChartCaption': 'Көпіршікті',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Драйверді талдау',
	'scatterChartCaption': 'Нүктелік',
	'lineChartCaption': 'Жол',
	'pointChartCaption': 'Нүкте',
	'heatChartCaption': 'Жылу картасы',
	'bulletChartCaption': 'Таңбалауыш',
	'waterfallChartCaption': 'Сарқырама',
	'radarChartCaption': 'Жапырақты',
	'boxplotChartCaption': 'Шаршы диаграммасы',
	'pieChartCaption': 'Дөңгелек',
	'mapChartCaption': 'Карта',
	'radialBarChartCaption': 'Радиалды',
	'compositeChartCaption': 'Сызық және баған',
	'wordCloudChartCaption': 'Сөз бұлты',
	'networkChartCaption': 'Желі',
	'relationshipNetworkChartCaption': 'Қатынас желісі',
	'treemapChartCaption': 'Тармақ картасы',
	'packedBubbleChartCaption': 'Бумаланған көпіршік',
	'hierarcicalPackedBubbleChartCaption': 'Иерархия көпіршігі',
	'spiralChartCaption': 'Спираль',
	'decisionTreeChartCaption': 'Шешімдер ағашы',
	'legacyMapChartCaption': 'Бұрынғы карта',
	'sunburstChartCaption': 'Секторлық дөңгелек',
	'visUsageComparison': 'Салыстыру',
	'visUsageRelationships': 'Қатынастар',
	'visUsageTrend': 'Тренд',
	'visUsagePartsToWhole': 'Толық бөліктер',
	'visUsageGeospatial': 'Геокеңістіктік',
	'visUsageAdvanced': 'Жетілдірілген талдаулар',
	'visUsageTablesAndSummary': 'Кестелер және жиынтық',
	'visUsageSocialInsights': 'Әлеуметтік түсініктер',
	'visUsageOther': 'Басқа',
	'visualizationAnalytics': 'Талдау',
	'autoBinActionText': 'Автоматты топтастыру',
	'filterAutobinActionText': 'Bin -дерді сүзгілеу',
	'memberCalculationActionText': 'Мүше есебі',
	'toolbarActionCalculation': 'Есептеуді жасау',
	'toolbarActionEditCalculation': 'Есепті өңдеу',
	'topBottomRankLabel': 'Дәреже (%{label})',
	'toolbarDeleteFilterActionText': 'Сүзгіш жою',
	'toolbarActionTopKeyDrivers': 'Драйверлерді көрсету',
	'toolbarActionCustomGroup': 'Пайдаланушылар тобы',
	'canNotCreateCustomGroup': 'Бұл пайдаланушы тобын жасай алмаймыз.',
	'aria_label_datatable': 'Дерек кестесі',
	'summaryCaption': 'Жиынтық',
	'MeasuresCaption': 'Көрсеткіштер',
	'MeasuresGroupCaption': 'Өлшемдер тобы (%{count})',
	'ValuesCaption': 'Мәндер',
	'turnInsightsOn': 'Түсініктемелерді қосу',
	'turnInsightsOff': 'Түсініктемелерді өшіру',
	'decisionRules': 'Ережелер',
	'decisionTree': 'Ағаш диаграммасы',
	'decisionSunburst': 'Ағаш секторлық дөңгелек диаграммасы',
	'switchToDecisionRules': 'Шешім ережелеріне ауысу',
	'switchToDecisionTree': 'Шешім ағашына ауысу',
	'data_group_less_then': '%{rangeTo}-дан аз',
	'data_group_to': '%{rangeFrom}-дан < %{rangeTo}-ға',
	'data_group_and_above': '%{rangeFrom} және одан жоғары',
	'nullValueContent': '(мәні жоқ)',
	'sum': 'Қосынды',
	'count': 'Есеп',
	'countdistinct': 'Ерекше мәндерді есептеу',
	'avg': 'Орташа',
	'min': 'Ең кіші',
	'max': 'Ең үлкен',
	'automatic': 'Теңшелім',
	'variance': 'Айырмашылық',
	'stddev': 'Стандартты ауытқу',
	'median': 'Медиана',
	'calculated': 'Есептелген',
	'none': 'Ешбір',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'Шақыру мәндері',
	'inputLabelPrompt': 'Мән',
	'inputPlaceholderPrompt': 'Мәнді енгізіңіз',
	'inputInvalidText': '%{dataType} түрі үшін жарамсыз енгізу',
	'unSupportedPrompt': 'Қолдау көрсетілмеген шақыру',
	'missingDataSource': 'Деректер көзін дұрыс таба алмады.',
	'unSupportedPromptType': 'Шақыру сценарийіне қолдау көрсетілмейді.',
	'preAggregateLabel': 'Деректер көзі ішінде жеке мәндерге қолдану',
	'postAggregateLabel': 'Есептегі жол мәндерін қолдану',
	'preAggregateText': 'Ауқым бақылау тақтасының ішінде көрсетілген мәндерді емес, дерек қайнар көзіндегі мәндерді пайдаланады.',
	'defaultAggregation_count': 'Есеп',
	'defaultAggregation_countdistinct': 'Ерекше мәндерді есептеу',
	'defaultAggregation_max': 'Ең үлкен',
	'defaultAggregation_min': 'Ең кіші',
	'defaultAggregation_avg': 'Орташа',
	'defaultAggregation_sum': 'Қосынды',
	'defaultAggregation_auto': 'Авто (%{aggregationType})',
	'keydriver_average': 'Жалпы орта',
	'keydriver_up_down': 'Жоғары не төмен орталармен бөлектелген топтар мақсатқа көп әсер етеді. Әдеттегідей емес жоғары немесе төмен орташа топтарда өте күшті әсер бар.',
	'keydriver_different': 'Бөлектелген топтарда жалпы бөлуден айтарлықтай ерекшеленетін бөлу бар. Бұл топтар мақсатқа көп әсер етеді.',
	'topOperator': 'Үстіңгі',
	'bottomOperator': 'Төменгі',
	'topBottomFact': '%{columnLabel} бойынша %{operator} %{value}%{percent}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Жоғарғы не төменгі санақты жойыңыз',
	'deleteTopBottomPercent': 'Жоғарғы немесе төменгі % жою',
	'topBottomTitle': 'Тек осы нысан',
	'deleteTopBottom': 'Жоғарғы не төменгі санақты жойыңыз',
	'editTopBottom': 'Жоғарғы не төменгі санақты өңдеңіз',
	'editTopBottomCount': 'Жоғарғы не төменгі санақты өңдеңіз',
	'editTopBottomPercent': 'Жоғарғы немесе төменгі % өңдеу',
	'deleteDrillOperation': 'Егжей-тегжейлі операциясын болдырмау',
	'ariaDeleteTopBottomCountLabel': 'Жоғарғы не төменгі санақты жою үшін DELETE пернесін басыңыз.',
	'ariaDeleteTopBottomPercentLabel': 'Жоғарғы немесе төменгі % жою үшін DELETE пернесін басыңыз.',
	'ariaEditTopBottomCountLabel': 'Жоғарғы не төменгі санақты өңдеу үшін ENTER пернесін басыңыз.',
	'ariaEditTopBottomPercentLabel': 'Жоғарғы немесе төменгі % өңдеу үшін ENTER пернесін басыңыз.',
	'ariaDeleteDrillStateLabel': 'Егжей-тегжейлі операциясын өңдеу үшін ENTER пернесін басыңыз..',
	'drillUpStateTitle': 'Жоғары жылжу',
	'drillDownStateTitle': 'Төмен жылжу',
	'ariaEditTopBottomLabel': 'Жоғарғы не төменгі санақты өңдеу үшін ENTER пернесін басыңыз.',
	'ariaDeleteTopBottomLabel': 'Жоғарғы не төменгі санақты жою үшін DELETE пернесін басыңыз.',
	'allKeyDriversLabel': 'Авто (барлық драйверлер)',
	'filter_drag_and_drop_single_dock': 'Сүзгілеу үшін бұл жерге деректерді сүйреп апарыңыз.',
	'filter_drag_and_drop_all_tabs': 'Барлық қойындыларды сүзгілеу үшін деректерді сүйреп апарыңыз.',
	'filter_drag_and_drop_current_tab': 'Қойындыны сүзгілеу үшін деректерді сүйреп апарыңыз.',
	'filter_empty_consume_mode': 'Ешбір сүзгі қолданылмаған.',
	'filterClearAllItems': 'Барлық сүзгілерді тазалау',
	'filterDeleteAllItems': 'Барлық сүзгілерді жою',
	'filterDockChevronLeft': 'Деректер бойынша айналдыру',
	'filterDockChevronRight': 'Деректер бойынша айналдыру',
	'filterIconLabel_Single': 'Сүзгілер',
	'filterIconLabel_Global': 'Барлық қойындылар',
	'filterIconLabel_Tab': 'Бұл қойынды',
	'filterIconTooltip_Single': 'Сүзгілер',
	'filterIconTooltip_Global': 'Барлық қойындыларға арналған сүзгілер',
	'filterIconTooltip_Tab': 'Бұл қойындыға арналған сүзгілер',
	'filterDropZoneTooltip_Single': 'Сүзгіні тастау аймағы',
	'filterDropZoneTooltip_Global': 'Барлық қойындылар үшін сүзгіден өткізу аймағы',
	'filterDropZoneTooltip_Tab': 'Бұл қойындының сүзу аймағы',
	'filterOverflowMenu': 'Қосымша',
	'expand': 'Кеңейту',
	'collapse': 'Тасалау',
	'filterDockItemNameAriaLabel': 'Сүзгі тілқатысуын іске қосу және сүзгіні анықтау үшін Enter пернесін басыңыз.',
	'filterItemCanvasMove': 'Кенепке қосу',
	'addToCascadeSet': 'Каскадтық жинаққа қосыңыз',
	'removeFromCascadeSet': 'Каскадтық жиыннан алып тастаңыз',
	'filterItemDelete': 'Сүзгіні жою',
	'filterInvertRange': 'басқасының бәрі: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': '%{from}-дан кейін емес',
	'filter_date_after': '%{from} кейін',
	'filter_date_before_except': '%{to}-дан бұрын емес',
	'filter_date_before': '%{to} алдында',
	'filter_date_between_except': '%{from}-%{to} арасында емес',
	'filter_date_between': '%{from} және %{to} арасында',
	'filterValueSeparator': ',',
	'filterAll': 'Барлық',
	'filter': 'Сүзгі',
	'filterExcept': 'қоспағанда %{values}',
	'filterDockToolbarButtonLabel': 'Сүзгіш қондырмасы',
	'navigateTitle': 'Келесіге шарлау',
	'navigateSelectColumn': 'Бағанды көрсету',
	'navigateSelectPath': 'Шарлау жолын таңдаңыз',
	'current_nav_group': 'Қазіргі навигациялық топ - %{navigation_group_name}',
	'next': 'Келесі',
	'previous': 'Алдыңғы',
	'multiselectMsg': '%{count} таңдалған',
	'errMsgFilterItemMissingTitle': '%{itemName} сүзгі мәндерін жүктеу мүмкін емес, себебі бұл мәндер осы деректер жиынтығында қол жетімді емес',
	'errMsgFilterItemGenericTitle': 'Сүзгі мәндері жүктелмейді',
	'textFilterItemsNotFound': 'Ешбір элемент қолжетімді емес.',
	'nullValueLabel': '(бос)',
	'filterConditionLabel': 'Сүзгілеу шарты',
	'filter_includesAll': 'Барлығын қамтиды',
	'filter_allMembersOfSet': 'Жиындың барлық мүшелері',
	'modelFilter': 'Сүзгі',
	'filtersTitle': 'Сүзгі сипаттары',
	'search': 'Іздеу',
	'clearTextFilterValue': 'Тазалау',
	'invertFilterSelection': 'Оралту',
	'modellingLoading': 'Жүктелуде...',
	'searchAll': 'Барлық бағандарды табыңыз',
	'toolbarActionPossibleKeyDrivers': 'Ауқымды өңдеу',
	'toolbarActionPossibleKeyDriversSubTitle': 'Драйверді талдау кестесінде ескерілетін элементтерді сол жақтан сүйреңіз',
	'toolbarActionSort': 'Сұрыптау',
	'toolbarActionSortAscending': 'Артуы бойынша',
	'toolbarActionSortDescending': 'Кемуі бойынша',
	'toolbarActionSortAuto': 'Авто (%{sortOrder})',
	'toolbarActionSortCustom': 'Теңшелетін',
	'toolbarActionFormat': 'Деректерді пішімдеу',
	'toolbarActionFormatText': 'Мәліметтерді форматтау (мәтін)',
	'toolbarActionFormatAbbreviation': 'Аббревиатура',
	'toolbarActionFormatNone': 'Авто',
	'toolbarActionFilter': 'Сүзгі',
	'toolbarActionTopBottom': 'Жоғары немесе төмен',
	'toolbarActionRmvShape': 'Кескінді жою',
	'toolbarActionToggleShapeDrop': 'Инфографика пішіні',
	'toolbarActionToggleShapeDropTitle': 'Инфографика жасау',
	'toolbarActionToggleShapeDropText': 'Инфографика жасау үшін осы өріске арналған пішінді сүйреңіз.',
	'toolbarActionAggregationType': 'Жинақтау',
	'toolbarDeleteActionText': 'Бағанды жою',
	'toolbarTextActionText': 'Мәтін мәнері',
	'toolbarActionFilterLocalKeepSelected': 'Сақтау',
	'toolbarActionFilterLocalExcludeSelected': 'Шығарып тастау',
	'toolbarActionFilterAllKeepSelected': 'Сүзгі',
	'toolbarActionSimpleCalculation': 'Қарапайым есептеулер',
	'toolbarActionDrillBack': 'Артқа',
	'toolbarActionDrillUp': 'Жоғары жылжу',
	'toolbarActionDrillDown': 'Төмен жылжу',
	'toolbarActionJumpTo': 'Егжей-тегжейлеу арқылы',
	'toolbarActionNavigate': 'Шарлау',
	'toolbarActionCreateFilterGroup': 'Жаңа байланыс жасау',
	'toolbarActionDisconnectFilterGroup': 'Барлық сілтемелерді бұзу',
	'toolbarActionLinkFilterGroup': 'Бар байланысқа қосу',
	'toolbarActionLassoSelect': 'Құралды таңдау',
	'toolbarActionRefreshDeveloperWidget': 'Жаңарту',
	'textFontFamilySubClassHairline': 'Жұқа сызық',
	'textFontFamilySubClassThin': 'Жіңішке',
	'textFontFamilySubClassThinItalic': 'Жіңішке көлбеу',
	'textFontFamilySubClassExtraLight': 'Қосымша жарық',
	'textFontFamilySubClassExtraLightItalic': 'Қосымша жарық көлбеу',
	'textFontFamilySubClassLight': 'Ашық',
	'textFontFamilySubClassLightItalic': 'Ашық көлбеу',
	'textFontFamilySubClassRegular': 'Қалыпты',
	'textFontFamilySubClassRegularItalic': 'Қалыпты көлбеу',
	'textFontFamilySubClassItalic': 'Көлбеу',
	'textFontFamilySubClassMedium': 'Орташа',
	'textFontFamilySubClassMediumItalic': 'Орташа көлбеу',
	'textFontFamilySubClassHeavy': 'Қалың',
	'textFontFamilySubClassHeavyItalic': 'Қалың көлбеу',
	'textFontFamilySubClassDemiBold': 'Жартылай қалың',
	'textFontFamilySubClassDemiBoldItalic': 'Жартылай қалың көлбеу',
	'textFontFamilySubClassBold': 'Қалың',
	'textFontFamilySubClassBoldItalic': 'Қалың көлбеу',
	'textFontFamilySubClassExtraBold': 'Қосымша қалың',
	'textFontFamilySubClassExtraBoldItalic': 'Қосымша қалың көлбеу',
	'textFontFamilySubClassBlack': 'Қара',
	'textFontFamilySubClassBlackItalic': 'Қара көлбеу',
	'textFontFamilySubClassStencil': 'Трафарет',
	'dlg_ascending': 'Артуы бойынша',
	'dlg_descending': 'Кемуі бойынша',
	'dlg_custom': 'теңшелім',
	'dlg_none': 'Ешбір',
	'dlg_hierarchy': 'иерархия',
	'dlg_namedSet': 'аталған жиын',
	'dlg_rank': 'дәреже',
	'visualizationLabel': 'Көрнекі бейне',
	'chartLabel': '%{chartName} диаграммасы',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Виджет арқылы шарлау үшін F12 түймешігін басыңыз',
	'f10KeyDescription': 'Виджеттің меңзеу көрінісін орналастыру үшін F10 түймешігін басыңыз',
	'playButtonLabel': 'Ойнау',
	'dataPlayerValueListLabel': 'Деректер ойнатқышының мәндері',
	'localFilterTitle': 'Тек осы нысан',
	'globalFilterTitle': 'Барлығы нысандар',
	'deleteFilter': 'Сүзгіні жою',
	'editFilter': 'Сүзгіні өңдеу',
	'ariaEditFilterLabel': 'Сүзгіні өңдеу үшін ENTER пернесін басыңыз.',
	'ariaDeleteFilterLabel': 'Сүзгіні жою үшін DELETE пернесін басыңыз.',
	'measureFilterBetween': '%{lowerBound} және %{upperBound} арасында',
	'measureFilterNotBetween': '%{lowerBound} және %{upperBound} арасында  емес',
	'dimFilterIn': 'Құрамында: %{in}',
	'dimFilterNotIn': 'Қоспайды: %{out}',
	'gtFilter': '%{lowerBound} қарағанда үлкенірек',
	'afterFilter': '%{төменгі_шекара}-дан кейін',
	'beforeFilter': '%{жоғарғы_шекара}-ға дейін',
	'gteFilter': '%{lowerBound}  параметрінен көп немесе оған тең',
	'ltFilter': '%{upperBound} қарағанда аз',
	'lteFilter': '%{upperBound} параметрінен аз немесе оған тең',
	'ariaEditPrompt': 'ENTER пернесін хабарлу мәнін өзгерту үшін басыңыз',
	'dataPointFilterTitle': 'Деректер нүктелері',
	'dataPointFilterIncludeSummary': '%{valueCount} дерек нүктесі ендірілген',
	'dataPointFilterExcludeSummary': '%{valueCount} дерек нүктесі шеттетілген',
	'widgetFiltersLabel': 'Виджет сүзгілері',
	'coachMarkTitleSpiralTarget': 'Ауқымды өңдеу',
	'coachMarkContentSpiralTarget': 'Мұнда мақсатыңызға арналған драйвер таңдауына кіруге және оны өзгертуге болады.',
	'srILVTreeLabel': 'Тізім',
	'geomapUnrecognizedLocations': 'Таныс емес орналасу орындары:',
	'geomapAmbiguousLocations': 'Мағыналы аймақтар:',
	'visualizationNotifications': 'Көрнекілендіру туралы хабарландырулар:',
	'dataNotifications': 'Деректер туралы хабарландырулар:',
	'autobinSuggestion': 'Автоматты топтауды іске қосу',
	'LIVE_empty_visualization_hint_title': 'Көрнекілігіңізді құру',
	'LIVE_empty_visualization_hint_description': 'Деректерді осы жерге немесе өрістерге сүйреңіз.',
	'LIVE_slots_required_field_description': '%{asterisk} Қажетті өрісті көрсетеді',
	'LIVE_slots_drag_and_drop_description': 'Көрнекілікті сүзгілеу және құру үшін өрістерге деректерді сүйреп апарып тастаңыз.',
	'tooltipSlotDefaultCaption': 'Кеңес',
	'tooltipSlotCompositeLineCaption': 'Қатар кеңесі',
	'tooltipSlotCompositeColumnCaption': 'Баған кеңесі',
	'dwErrorLoadingAvailableVisualizations': 'Қолжетімді көрнекі бейне анықтамаларын жүктей алмаймыз',
	'moreDataIndicator': 'Сіздің дерегіңіз %{threshold} элементте қиылды. Сүзгіні аз көрсету үшін қабылдаңыз.',
	'nonCtxTopBottomInvalid': 'Жоғары немесе төменгі ережені мәтінмәнсіз анықтауға айқас кестелер үшін қолдау көрсетілмейді. Бұл айқас кесте көрінісінен жойылды.  %{columnName} мәтінмәнінде бір немесе бірнеше санаттар туралы ережені қайта анықтаңыз.',
	'dwErrorLoadingVisualizationNotFound': 'Біз нысанды жүктей алмаймыз, өйткені онда көрнекілендіру анықтама жоқ.',
	'dwErrorLoadingVisualizationListNotFound': 'Көрнекі бейнені жүктей алмадық.',
	'dwErrorRunningQuery': 'Деректер жиынынан %{datasetName} деректерін шығарып ала аласыз.',
	'dwErrorGeoData': 'Картада географиялық деректерді көрсетудегі қиындықтармен кездестік. Өзге көрнекі бейне түрін таңдауыңызды өтінеміз.',
	'dwPromptSignonCancelWarning': 'Бұл көрсетілімге арналған дерек қол жетімсіз. Дұрыс тіркелгілерді қамтамасыз етіңіз.',
	'dwErrorMissingDataset': 'Біз көрнекілікті жүктей алмаймыз, өйткені оған қатысты мәліметтер жиынтығы "%{datasetName}" қол жетімді емес.',
	'dwErrorRenderingVisualization': 'Бұл көрнекі бейнені жүктей алмадық.',
	'dwErrorVisualizationTooSmall': 'Қамтитын деректерді көрсету үшін көрнекі бейне тым кішкентай. Көрнекі бейнені үлкейтіңіз не құрамындағы деректерге шектеу орнатыңыз.',
	'errorSourceNotFound': 'Біз көрнекілендіруді жүктей алмаймыз, себебі "%{sourceName}"-мен байланыстырылған көзі қол жетімді емес.',
	'errorActionNotSupported': 'Бұл әрекетке "%{sourceName}" деректер көзі үшін қолдау көрсетілмейді.',
	'errorMeasureNotSupportedOnMultiEdges': 'Көрнекілендірудің бірнеше шеттерінде өлшемдер бар, енді ол қолдау көрсетілмейді. Көрсеткіштерді тек бір жиекке қойыңыз.',
	'errorExceedAllowableValue': 'Ұяшықтардың болжамды саны 100000 мәнінен асады. Ұяшықтардың санын азайту үшін сүзгілеуді жобаланған жиындарға қолданыңыз.',
	'propScaleLabel': 'Белгішелер саны',
	'propScaleDescription': 'Белгішелер санын таңдау',
	'propScaleFew': 'Төмен',
	'propScaleDefault': 'Әдепкі',
	'propScaleMany': 'Жоғары',
	'lastRefresh': 'Соңғы жаңарту: %{timeInterval} бұрын',
	'widgetTimer': 'Виджет таймері',
	'datasetItemsUnavailable': 'Бұл көрнекі бейнеде қолданылған кейбір деректер жиыны элементтері қолжетімсіз.',
	'datasetItemUnavailable': 'Бұл деректер жиыны элементі қолжетімсіз',
	'retry': 'Әрекетті қайталау',
	'widgetConditionalFormatLabel': 'Шартты пішім басқаруларын ажырата қосу',
	'widgetConditionalFormatTitle': 'Шартты пішімдеу түсін өңдеңіз',
	'crosstabName': 'Қарсы',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'қол жеткізгісіз',
	'summaryLabel': '%{label} %{value} мәнімен',
	'infographicLabel': '%{label} %{value} мәнімен',
	'warning': 'Ескерту',
	'swapRowsAndColumns': 'Жолдар мен бағандарды алмастыру',
	'hideSummariesLabel': 'Жиынтықтарды жасыру',
	'showSummariesLabel': 'Жиындарды көрсету',
	'hideRowColumn': 'Жасыру',
	'showAllRowColumn': 'Барлығын көрсету',
	'dataAssetPropertiesLabel': 'Визуалдау сипаттары',
	'evAdd': 'Баған қосу',
	'evCollapse': 'Тасалау',
	'evColumns': 'Бағандар',
	'evLocalFilters': 'Жергілікті сүзгілер',
	'evExpand': 'Кеңейту',
	'evFilterTooltip': 'Сүзгі',
	'missingColumn': 'Жоқ: %{columnLabel}',
	'missingFiltering': 'Бағандарда сүзгілер жоқ:',
	'missingDataItem': 'Сілтеме берілген "%{dataItemId}" элементі виджетте табылған жоқ.',
	'heatByLabel': 'Қатынасу жиілігі арқылы',
	'toolbarChangeVisualization': 'Көрнекі бейнелерді өзгертіңіз',
	'modellingRelatedTablesNoneFound': 'Байланысты кестелер табылмады',
	'tablesNotJoined': 'Кестелер арасындағы өзара байланыс анықталмаған.',
	'fixTableJoin_edit': 'Өзара байланыстарды көру',
	'processing': 'Өңделуде...',
	'errorCellWarning': 'Кейбір жиынтық мәндерді есептеу мүмкін болмады.',
	'aggregateTypeToggler': 'Агрегация түрін көрсетіңіз',
	'maxColumnsExceeded': 'Бағандар саны шегінен асты. %{columns} төмендеді.',
	'unboundColumns': 'Келесі бағандарды пайдалану мүмкін емес: %{columns}.',
	'unboundColumn': 'Келесі бағанды пайдалану мүмкін емес: %{columns}.',
	'recommendRequestFailed': 'Ұсыныс сұрауы сәтсіз аяқталды. Әкімшіңізге хабарласыңыз.',
	'visualizationDoesNotSupportOLAP': 'OLAP деректер көзіне негізделген осы көрнекілендіруді жасай алмаймыз. Басқа қолдайтын деректер көзін пайдаланыңыз.',
	'showDataBehindVizLabel': 'Деректерді көрсету',
	'showDataBehindVizNotSupportedLabel': 'Деректерді көрсету бұл көрнекілендіру түріне қолдау көрсетілмейді',
	'exploreData': 'Зерттеу...',
	'newExplore': 'Жаңа зерттеу',
	'thumbnails_error_fetching': 'Эскиздерді алу қатесі',
	'loadedThumbnailImage': '%{visType} көрнекілендіру нобайы жүктелді',
	'autobinAxisLabel': 'топтар',
	'recommended_visualizations': 'Ұсынылған көрнекілендірулер',
	'all_visualizations': 'Барлық көрнекі бейнелер',
	'edit': 'Өңдеу',
	'selectTargetDialogTitle': 'Егжей-тегжейлі мақсатты таңдаңыз',
	'noTargetInCM': 'Егжей-тегжейлі мақсатты табу мүмкін емес',
	'errorDrillDefinition': 'Жылжыту бойынша анықтаманы қосқан немесе өңдеген кезде бірдеңе дұрыс болмады.',
	'errorDrillToTarget': '"%{targetName}"-ға жылжыту кезінде қате пайда болды',
	'drillThroughMappingViewLabel': 'Бақылау тақтасындағы бағандарды мақсатты есептің нұсқауларына тағайындаңыз',
	'drillthroughScopeRadioLabel': 'Осы анықтаманы келесіге қолданыңыз:',
	'drillthroughScopeRadioOptionVisualization': 'Бұл көрнекілендіру ғана',
	'drillthroughScopeRadioOptionConnection': 'Дәл сол дерек көзін пайдаланатын қосылымдағы көрнекілендірулер',
	'drillthroughScopeRadioOptionDashboard': 'Деректер көзін пайдаланатын %{perspective} кез-келген көрннекілендіру',
	'drillThroughParametersColumnTitle': '"%{targetName}" шақырады:',
	'drillThroughMetadataColumnTitle': '"%{boardName}" деректер бағандары:',
	'drillThroughDefinitionNoParameter': 'Егжей-тегжейлі мақсатты нұсөаулары болмайды.',
	'drillThroughDefinitionErrorQueryingReport': 'Мақсатты есеппен мәселені түзетіп, егжей-тегжейлі анықтаманы жасаңыз.',
	'drillThroughDefinitionErrorDlgTitle': 'Бірдеңе дұрыс емес болды',
	'dlg_back': 'Қайту',
	'dlg_close': 'Жабу',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Болдырмау',
	'dlg_apply': 'Қолдану',
	'dlg_create': 'Жасау',
	'dlg_done': 'Аяқталды',
	'drillthrough_unsaveMsg': '"%{name}"-ны сақтамай жалғастыру керек пе?',
	'drillthrough_jumpTo': 'Егжей-тегжейлі анықтама: %{name}',
	'drillthrough_jumpToLabel': 'Егжей-тегжейлеу арқылы',
	'drillthrough_manage': 'Басқару...',
	'drillthrough_addNewTarget': 'Жаңа егжей-тегжейлі анықтаманы қосу',
	'drillthrough_manageJumpPaths': 'Егжей-тегжейлі анықтамаларды басқарыңыз',
	'drillthrough_manageJumpPaths_edit': 'Өңдеу "%{name}"',
	'drillthrough_manageJumpPaths_delete': 'Жою "%{name}"',
	'drillthrough_manageAddAnotherTarget': 'Басқа егжей-тегжейлі анықтаманы қосыңыз',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Жоюды растау',
	'drillthrough_manageConfirmeDeleteDrillTarget': '"%{name}"-ны егжей-тегжейлі жойғыңыз келе ме?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Қайталанатын егжей-тегжейлі аты',
	'drillthrough_definitionMessage': 'Егжей-тегжейлі "%{name}" бұрыннан бар. Басқа атау беріңіз',
	'drillthrough_jumpToTarget_notFound': '"%{name}"-ны егжей-тегжейлеу үшін мақсат табылмады',
	'drillThroughDefinitionNoParameterSubTitle': 'Мақсатты есепке мәтінмән жіберілмейді',
	'drillthrough_titleLabel': 'Аты',
	'drillthrough_create_dialogTitle': 'Егжей-тегжейлі анықтама жасаңыз',
	'drillthrough_edit_dialogTitle': 'Егжей-тегжейлі анықтаманы өңдеу',
	'drillthrough_subTitle': 'Сіздің көзіңіздегі көрнекілендіру мәтінмәні %{perspective} нысанын сүзу үшін қолданылады.',
	'drillthrough_selectColumn': 'Бағанды көрсету',
	'noPrompt': 'Кеңес хабарлар жоқ',
	'promptDialog': '%{promptType} жедел тілқатысу терезесі',
	'formatAutoDescription': 'Авто деректер көзінен немесе көрнекілендіруден мұраланған пішімді анықтайды.',
	'formatDefaultDescription': 'Әдепкіде жүйеден мұраланған пішім анықталады',
	'createCustomGroupAction': 'Деректер тобын жасау',
	'removeCustomGroupAction': 'Деректер тобын жою',
	'editCustomGroupAction': 'Деректер тобын өңдеу',
	'renameCustomGroupAction': 'Деректер тобын қайта атаңыз',
	'createCustomGroupErrorToast': 'Сіздің деректер тобыңызды жасау мүмкін емес.',
	'removeCustomGroupErrorToast': 'Сіздің деректер тобыңызды жою мүмкін емес.',
	'editCustomGroupErrorToast': 'Сіздің деректер тобыңызды өзгерту мүмкін емес.',
	'renameCustomGroupErrorToast': 'Деректер тобын қайта атау мүмкін болмады.',
	'customGroupLabel': 'Деректер тобын жасау',
	'ungroupCustomGroupLabel': 'Топтамау',
	'renameCustomGroupLabel': 'Атын өзгерту',
	'createCustomGroupLabel': 'Жасау',
	'customGroupingLabel': '%{columnLabel} (Топ)',
	'createCustomBinningErrorToast': 'Сіздің авто тобыңыз жасалмады.',
	'removeCustomBinningErrorToast': 'Авто тобыңызды жою мүмкін болмады.',
	'createCustomSort': 'Пайдаланушылық сұрыптауды жасаңыз',
	'unavaiableData': 'Деректер жоқ',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': 'Қолжетімді элементтерді таңдап, оларды пайдаланушылық сұрыптауды жасау үшін қайта реттеңіз.',
	'availableItems': 'Қолжетімді элементтер',
	'selectAll': 'Барлығын таңдау',
	'customSortOrder': 'Пайдаланушылық сұрыптау реті',
	'selectAvailableItemsDesc': 'Қол жетімді элементтерді таңдап, оларды осында қайта реттеңіз.',
	'moveToTop': 'Жоғарырақ жылжыту',
	'clear': 'Тазалау',
	'sortRemainingItemsBy': 'Басқа элементтерді сұрыптау',
	'removeAll': 'Барлығын жою',
	'resetTooltip': 'Барлық элементтер %{customSortOrder} тізімінен жойылады. Сонымен, %{sortRemainingItemsBy} ашылмалы терезесі әдепкіге қайта оралады.',
	'manyItemsWarning': 'Көптеген элементтерді таңдау сіздің бақылау тақтаңыздың жұмысына әсер етуі мүмкін.',
	'manyItemsSelected': '%{maxItems}-дан астам элементтер таңдалған, бұл сіздің бақылау тақтаңыздың жұмысына әсер етуі мүмкін.',
	'somethingWentWrong': 'Ойбай. Бірдеңе дұрыс емес.',
	'tryAgain': 'Әрекетті қайталау',
	'customSortLabel': 'Теңшелетін сұрыптау',
	'applyError': '%{action} қолдану мүмкін емес.',
	'searchReturnedNoResults': 'Хм, сіздің іздеуіңіз нәтиже берген жоқ.',
	'extVisSystem': 'Жүйе',
	'extVisCustom': 'Теңшелетін',
	'customVisTestVisualization': 'Тексеру көрнекілендіруі',
	'extVisCustomVisPreview': 'алдын ала көріп алу',
	'extVisCustomPreviewWidgets': 'Әзірлеуші виджеттері',
	'extVisCustomVVisualization': 'Көрнекі бейне',
	'extVisCustomVisuals': 'Теңшелетін көрнекі құралдар',
	'noPermissionToManage': 'Теңшелетін көрнекілендіруді басқаруға рұқсатыңыз жоқ.',
	'extVisCustomUpdate': 'Жаңарту',
	'extVisCustomDelete': 'Жою',
	'extVisNoCustomVisuals': 'Теңшелетін көрнекілендірулер жоқ',
	'extVisNoCustomVisualsMsg': 'Қазіргі уақытта ұйымыңызда теңшелетін көрнекілендірулер жоқ',
	'extVisAddCustomVisual': 'Теңшелетін көрнекілендіруді қосу',
	'extVisNoCustomVisualsAdminMsg': 'Қазіргі уақытта теңшелетін көрнекілендірулер жоқ. Жұмысты бастау үшін біреуін қосыңыз',
	'extVisNoSDKConnection': 'Жергілікті файлыңызға байланыс орнатылмады',
	'extVisNoSDKPreviewMsg': 'Көрнекіленуді алдын-ала көру үшін байланыс орнатыңыз.',
	'extVisMore': 'Қосымша',
	'extVisDeleteDialogTitle': 'Теңшелетін көрнекілендіруді жою',
	'extVisDeleteDialogBody': 'Осы теңшелетін көрнекілендіруді жойғыңыз келе ме? Бұл басқа да бақылау тақталары мен есептермен қолданылуы мүмкін.',
	'extVisDeleteConfirmation': 'Теңшелетін көрнекілендіруіңіз жойылды.',
	'extVisDeleteError': 'Сіздің теңшелетін көрнекілендіруіңізді жою мүмкін емес. %{msg}',
	'extVisCloseToast': 'Қазір жабыңыз',
	'extVisAdd': 'Сіздің теңшелетін көрнекілендіруңіз сәтті қосылды.',
	'extVisAddError': 'Сіздің теңшелетін көрнекілендіруңізді қосуға болмады. %{msg}',
	'extVisUpdate': 'Сіздің теңшелетін көрнекілендіруңіз сәтті жаңартылды.',
	'extVisUpdateError': 'Сіздің теңшелетін көрнекілендіруңізді жаңарту мүмкін емес. %{msg}',
	'extVisAddProgress': 'Импорттау %{name}',
	'extVisUpdateProgress': 'Жаңартылуда %{name}',
	'extPermissionTitle': 'Шектеулі қатынас немесе жойылған теңшелетін көрнекілендіру',
	'extPermissionBody': 'Бұл теңшелетін көрнекілендіруді қарау мүмкін емес, себебі ол жойылған немесе кіруге шектеу қойылған.',
	'customVizSaveWarning': 'Теңшелетін көрнекілерді сақтау мүмкін емес. Олар импорталған жоқ.',
	'schematicTestCaption': 'Тексеру схемасы',
	'schematicServiceRequestError': 'Қызметтік схема қатесі',
	'extVisPreviewMessage': 'Бұл алдын ала қарау. Көрнекілендіру әлі өнімге қосылмаған.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Анықталмаған',
	'kpiDefaultTargetLabel': 'Мақсаты',
	'kpiNonNumericTarget': 'Мақсатты мән сан болуы керек.',
	'kpiManualTargetSlotFilled': 'Өрісне қолданылатын мән',
	'kpiAutoValueSize': 'Авто',
	'kpiUnableDrawSparklineLabel': 'Спарклайнды сызу мүмкін емес',
	'kpiUnableDrawSparklineInfo': 'Спарклайн ең аз дегенде екі нүктені қажет етеді. Спарклайн көру үшін деректерді өзгертіңіз немесе сүзгілерді реттеңіз.',
	'conditionalFormattingTextColor': 'Мәтін түсі',
	'suppression': 'Басу',
	'suppressNone': 'Ешбір',
	'suppressRowsAndColumns': 'Жолдар және бағандар',
	'suppressRows': 'Жолдар',
	'suppressColumns': 'Бағандар',
	'enableSuppression': 'Басуды қосу',
	'disableSuppression': 'Басуды ажырату',
	'loadVisDefinitionError': 'Көрнекілендіру үшін анықтаманы жүктеу мүмкін емес %{id}',
	'emptyVisualization': 'Бос көрнекілендіру',
	'expandCollapse': 'Кеңейту & Тасалау',
	'expandBtnLabel': 'Кеңейту',
	'collapseBtnLabel': 'Тасалау',
	'prop_sizeInputNonNumericValue': 'Мән сан болуы керек.',
	'prop_sizeValueShouldBeHigher': 'Мән %{value}-дан үлкен болуы керек.',
	'fontPropLabel': 'Қаріп жиынтығы',
	'fontSizePropLabel': 'Қаріп өлшемі',
	'sectionItemAxisTitle': 'Элемент осінің тақырыбы',
	'sectionItemAxisLabel': 'Элемент осінің белгісі',
	'sectionValueAxisTitle': 'Мән осінің тақырыбы',
	'sectionValueAxisLabel': 'Мән осінің белгісі',
	'sectionRepeatColumnTitle': 'Баған атауын қайталау',
	'sectionRepeatRowTitle': 'Қатар атауын қайталау',
	'styletext-widget.legend': 'Оқиға',
	'styletext-itemAxis.ticks.labels': 'Осьтің белгілері',
	'styletext-valueAxis.title': 'Осьтің тақырыптары',
	'styletext-itemAxis.title': 'Осьтің тақырыптары',
	'styletext-labels': 'Деректер белгілері',
	'styletext-valueAxis.line.title': 'Сызық тақырыптары',
	'styletext-cellValue': 'Мәндер',
	'styletext-values': 'Мәндер',
	'styletext-rowHeading': 'Жолдардың тақырыптары',
	'styletext-columnHeading': 'Баған тақырыбы',
	'regularFontStyle':'Қалыпты',
	'fontFamily': 'отбасы',
	'fontSize': 'өлшем',
	'visExportFileName': 'Көрнекі бейне',
	'ds-missingDataSet': 'Деректер жиынтығы табылмады. Деректер жиынтығы сәтті жасалғанына көз жеткізіңіз.',
	'ds-missingDashboardId': 'Деректер қорын жасамас бұрын бақылау тақтасын сақтаңыз.',
	'ds-unsupportedDataSourceType': '%{type} деректер көзі түріне қолдау көрсетілмейді.',
	'dataCache': 'Деректер кэші',
	'dataCache_on': 'Сеансты қосу',
	'dataCache_off': 'Кэш жоқ',
	'dataCache_auto': 'Автоматты',
	'queryOptimization': 'Сұрауды оңтайландыру',
	'propshowDataGridInConsumeMode': 'Алдын ала көріністе деректер торын көрсету',
	'dtMatchMetadata': 'Мақсатты бақылау тақтасын сүзу үшін сәйкес метадеректерді пайдаланыңыз.',
	'dtMatchMetadata_info': 'Мақсатты бақылау тақтасы басқа деректер көзіне негізделген болса, метадеректер идентификаторлары сәйкес келгенде сүзгілерді қолданыңыз. Бұл өнімділікке әсер етуі мүмкін.',
	'dtOverrideExistingFilters': 'Мақсатты бақылау тақтасында бұрыннан бар жаһандық сүзгілерді ғана қайта анықтаңыз.\nБастапқы визуализациядағы басқа сүзгілер еленбейді.',
	'OnLoadFilterModifierDatasourceMismatch': 'Сүзгілер нысанаға қолданылмайды, өйткені бақылау тақталарында әртүрлі көздер қолданылады.',
	'OnLoadFilterModifierColumnMismatch': 'Бір немесе бірнеше сүзгілер қолданылмады, өйткені сәйкес баған (дар) табылмады.',
	'showValuesOn': 'Мәндерді көрсету',
	'showValuesAsRowLabel': 'Жолдар (ең жақсы кезде)',
	'showValuesAsColumnLabel': 'Бағандар (ең жақсы кезде)',
	'dropdownMultiSelectClearAll': 'Барлық таңдауларды жою',
	'dropdownSingleSelectClearAll': 'Таңдауды жою',
	'dropdownOpenMenu': 'Мәзірді ашу',
	'dropdownCloseMenu': 'Мәзірді жабу',
	'cascadingFiltersSection': 'Каскадты сүзгі параметрлері',
	'cascadeStrategy': 'Каскадтық жиынтық стратегиясы',
	'cascadeStrategy_FirstToLast': 'Біріншіден соңғыға',
	'cascadeStrategy_MultiDirectional': 'Көп бағытты',
	'cascade_globalToTab': 'Барлық қойындылар сүзгілерін каскадтау',
	'cascade_tabToLocal': 'Осы қойынды сүзгілерін жергіліктіге каскадтау',
	'showAllData': 'Барлық мәндерді көрсету',
	'showAllFilterValue': '(%{value})',
	'valuesCascaded': 'Барлық қойындылар арқылы сүзілген мәндер',
	'AnalyticsMsgDefault': 'Таңдалған виджет болжауды немесе талдамалы инсайтарты пайдаланбайды',
	'AnalyticsDescriptionDefault': 'Талдау параметрлерін көру және басқару үшін аналитикалық қолдауы бар визуализацияны таңдаңыз.',
	'AnalyticsMsgNoContent': 'Көрнекілендіру таңдалмаған',
	'AnalyticsMsgMultiSelected': 'Бірнеше виджеттер таңдалды',
	'AnalyticsDescriptionMultiSelected': 'Аналитикалық параметрді көру және басқару үшін бір визуализацияны таңдаңыз.',
	'ChartInsightPinnedSectionDescription':'Сіз бақылау тақтасын бөліскен кезде сіздің таңдаулы сипаттамалық мәліметтеріңіз де бөлісіледі. Мәліметтерге деректер өзгерістері әсер етуі мүмкін және олар ағымдағы деректерге қолданылмаса, көрсетілмейді.',
	'ChartInsightNonPinnedSectionDescription':'Ұсынылған мәліметтер сіздің визуализацияңыз үшін жүйе тарапынан жасалған. Егер деректерде өзгеріс болса, бұл мәліметтер өзгеруі мүмкін.',
	'ChartInsightPinnedSectionTitle':'Таңдаулы мәліметтер (%{count})',
	'ChartInsightNonPinnedSectionTitle':'Ұсынылған мәліметтер (%{count})',
	'ChartInsightPinnedEmpty':'Қандай да бір ұсынылған мәліметті таңдаулы ретінде қосу үшін оның жанындағы жұлдызша белгішесін басыңыз.',
	'ChartInsightAllInsightsPinned': 'Қолжетімді жаңа мәліметтер жоқ немесе барлық ұсынылған мәліметтер таңдаулылар қатарына қосылды.',
	'ChartInsightNoRecommendedInsights': 'Бұл визуализация үшін мәліметтер жоқ.',
	'ChartInsightLoadingMessage':'Деректеріңіз үшін сипаттамалық мәліметтер ізделуде',
	'ChartInsightConsumePinnedInsightsDesc': 'Бақылау тақтасының авторы бұл мәліметтерді таңдаулылар қатарына қосты.',
	'MoveUp':'Мәліметті жоғары қарай жылжыту',
	'MoveDown':'Мәліметті төмен қарай жылжыту',
	'Star':'Таңдаулыларға мәлімет қосу',
	'Unstar':'Таңдаулылардан мәлімет алып тастау',
	'DisabledUnstar': 'Таңдаулылар қатарына қосылған мәлімет',
	'PdfPrintSectionLabel': 'PDF басып шығару параметрлері',
	'PdfPrintOptionsLabel': 'Басып шығару опциялары',
	'PdfPrintInViewLabel': 'Көріністе',
	'PdfPrintExtendedContentLabel': 'Кеңейтілген мазмұн',
	'PdfPrintNewPageLabel': 'Жаңа бет'
});
